import { render, staticRenderFns } from "./FormRatingInternationalization.vue?vue&type=template&id=d5745094&"
import script from "./FormRatingInternationalization.vue?vue&type=script&lang=js&"
export * from "./FormRatingInternationalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports